import currentPage from './current-page';

const rules = { currentPage };

export default rules;
